
























import Vue, { PropOptions } from 'vue';

export type HeroLanding = Blok & {
  heading: string;
  subheading: string;
  callToAction: Blok[];
  media: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<HeroLanding>,
  },
});
